// import Index from '@/components/index.vue'
import DashboardView from '@/views/DashboardView.vue'
import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'DashboardView',
    component: DashboardView
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.VUE_APP_BASE_API,
  routes
})

export default router
